import dayjs, { APP_TZ } from "../../../utils/dateTime";

export const SEMINAR_TYPES = [
  "SEMINAR",
  "WORKSHOP",
  "TRAINING",
  "WEBINAR",
  "CONFERENCE",
];
export const SEMINAR_MODES = ["ONSITE", "ONLINE", "HYBRID"];

/** "WEBINAR" → "Webinar" */
export const titleCase = (v) =>
  v ? v.charAt(0) + v.slice(1).toLowerCase() : "—";

export const PHASE = {
  UPCOMING: { label: "Upcoming", tone: "blue" },
  ONGOING: { label: "Ongoing", tone: "amber" },
  ENDED: { label: "Ended", tone: "gray" },
};

// Participant attendance status
export const PARTICIPANT_STATUS = {
  PENDING: { label: "Pending", tone: "gray" },
  ATTENDED: { label: "Attended", tone: "green" },
  ABSENT: { label: "Absent", tone: "red" },
  EXCUSED: { label: "Excused", tone: "amber" },
};

/** How a participant's attendance was logged; "" while nothing is logged. */
export const checkInMethodLabel = (p) => {
  if (p.checkInMethod === "SELF") return "Self";
  if (p.checkInMethod === "QR") return "QR";
  return p.status && p.status !== "PENDING" ? "Organizer" : "";
};

/** ISO → value for <input type="datetime-local"> in Manila time. */
export const toLocalInput = (iso) =>
  iso ? dayjs(iso).tz(APP_TZ).format("YYYY-MM-DDTHH:mm") : "";
/** <input type="datetime-local"> value (Manila) → ISO. */
export const fromLocalInput = (v) =>
  v ? dayjs.tz(v, "YYYY-MM-DDTHH:mm", APP_TZ).toISOString() : null;

/** "Oct 20, 2026 9:00 AM – 5:00 PM" or across days. */
export const formatSchedule = (startAt, endAt) => {
  if (!startAt) return "—";
  const s = dayjs(startAt).tz(APP_TZ);
  const e = endAt ? dayjs(endAt).tz(APP_TZ) : null;
  if (!e) return s.format("MMM D, YYYY h:mm A");
  return s.isSame(e, "day")
    ? `${s.format("MMM D, YYYY h:mm A")} – ${e.format("h:mm A")}`
    : `${s.format("MMM D, YYYY h:mm A")} – ${e.format("MMM D, YYYY h:mm A")}`;
};

/** Timestamp or plain date → "Oct 20, 2026" (Manila). */
export const formatDay = (v) =>
  v ? dayjs(v).tz(APP_TZ).format("MMM D, YYYY") : "—";
